import { useEffect } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';
import { importWithRetry } from '@trello/use-lazy-component';
import type { reportWebVitals as reportWebVitalsFn } from '@trello/web-vitals';

export const useWebVitalsReporter = () => {
  const { value: shouldSendMemoryAttributes } = useFeatureGate(
    'goo_send_memory_attributes',
  );

  useEffect(() => {
    const importAndRun = async () => {
      const { reportWebVitals } = await importWithRetry<{
        reportWebVitals: typeof reportWebVitalsFn;
      }>(
        () => import(/*webpackChunkName: "web-vitals" */ '@trello/web-vitals'),
      );

      reportWebVitals({
        shouldSendMemoryAttributes,
        meta: {
          isBoardCanvasModernizationEnabled: true,
        },
      });
    };

    try {
      importAndRun();
    } catch (err) {
      // noop
    }
  }, [shouldSendMemoryAttributes]);
};
